import { elasticOut } from "svelte/easing";

export function scaleAndShift(node, params) {
  const existingTransform = getComputedStyle(node).transform.replace(
    "none",
    ""
  );
  const { x = 0, y = 30 } = params;
  return {
    delay: params.delay || 0,
    duration: params.duration || 200,
    easing: params.easing || elasticOut,
    css: (t, u) =>
      `transform: ${existingTransform} translate(${x * u}px,${
        y * u
      }px) scale(${t}); opacity: ${t};`,
  };
}

export function scaleFade(node, params) {
  const existingTransform = getComputedStyle(node).transform.replace(
    "none",
    ""
  );
  const { x = false, y = false } = params;
  return {
    delay: params.delay || 0,
    duration: params.duration || 200,
    easing: params.easing || elasticOut,
    css: (t, u) =>
      `transform: ${existingTransform} scale(${x ? t : 1}, ${
        y ? t : 1
      }); opacity: ${t};`,
  };
}
